import BrightSpaceValenceApiReaderNode from './types/brightspace-valence-api-reader';
import BrightSpaceValenceApiWriterNode from './types/brightspace-valence-api-writer';

export const brightspaceNodes = {
  brightSpaceValenceApiWriter: BrightSpaceValenceApiWriterNode,
  brightSpaceValenceApiReader: BrightSpaceValenceApiReaderNode,
};
